import React from "react";
import { connect } from "react-redux";
import ReportSiniestro from "powerbi-report-component";
const config = {};


class SiniestrosGrafico extends React.PureComponent {
  render() {
    const reporte = [];
    if (this.props.companyId) {
      config.embedUrl = `${this.props.config.embedUrl}&pageName=ReportSection5e6e910a240b2705c011&filter=Siniestros/Siniestro_RutEmpresa eq '${this.props.companyId}' and Estructura_x0020_Meses_x0020_Siniestro/Siniestro_Meses eq '${this.props.range} Meses'`;
      if (!(this.props.sucursalId === "")) { config.embedUrl += ` and Siniestros/Siniestro_BP_Sucursal eq '${this.props.sucursalId}'`; }

      config.extraSettings = {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        allowFullScreen: false,
      };

      const key = `siniestro${new Date().getTime()}`;
      reporte.push(<ReportSiniestro
        key={key}
        embedType={this.props.config.embedType}
        tokenType={this.props.config.tokenType}
        accessToken={this.props.EmbedTokenPowerBi}
        embedUrl={config.embedUrl}
        embedId={this.props.config.embedId}
        extraSettings={{
          filterPaneEnabled: config.extraSettings.filterPaneEnabled,
          navContentPaneEnabled: config.extraSettings.navContentPaneEnabled,

        }}

        permissions="All"
        style={{
          height: "300px",
          border: "0",
          padding: "0px",
          background: "#eee",
        }}
      />);
    }


    return (
      <React.Fragment >
        {reporte}
      </React.Fragment>

    );
  }
}
const mapStateToProps = (state) => ({

  config: state.graficos.config,
  EmbedTokenPowerBi: state.graficos.EmbedTokenPowerBi,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  range: state.resumenEmpresa.range,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(SiniestrosGrafico);

